import { render, staticRenderFns } from "./Ads_Management.vue?vue&type=template&id=22f2b6fa&scoped=true&"
import script from "./Ads_Management.vue?vue&type=script&lang=js&"
export * from "./Ads_Management.vue?vue&type=script&lang=js&"
import style0 from "./Ads_Management.vue?vue&type=style&index=0&id=22f2b6fa&prod&scoped=true&lang=scss&"
import style1 from "./Ads_Management.vue?vue&type=style&index=1&id=22f2b6fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2b6fa",
  null
  
)

export default component.exports